'use client';

import { Button } from 'primereact/button';
import { useState } from 'react';
import { CreateExperienceDialog } from './CreateExperienceDialog';

interface CreateExperienceProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  label?: string;
}

export const CreateExperience = ({ onSuccess, onError, label = 'Create' }: CreateExperienceProps) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <Button
        icon="pi pi-plus"
        label={label}
        onClick={() => setShowDialog(true)}
        className="p-button-primary"
        tooltip="Create new experience"
        tooltipOptions={{ position: 'top' }}
      />

      <CreateExperienceDialog
        visible={showDialog}
        onHide={() => setShowDialog(false)}
        onSuccess={onSuccess}
        onError={onError}
      />
    </>
  );
};
